import React, { useState, useEffect, useRef } from 'react';
import Map, { Source, Layer } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import MapPoints from './MapPoints'; // Adjust the path based on your project structure
import eezData from './eez.geojson'; // Import the GeoJSON file

const MapboxMap = ({ onMarkerClick }) => {
  const [viewport, setViewport] = useState({
    latitude: 7.2,
    longitude: 80.4194,
    zoom: 5,
  });
  const [vessels, setVessels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const mapRef = useRef(null); // Reference to the Mapbox map instance

  // Fetch vessel data
  useEffect(() => {
    const fetchVesselData = async () => {
      try {
        const response = await axios.get(
          'https://api.starmarketapi.online/vessel_service1/vessel/v1/vessels/*'
        );
        setVessels(response.data.vesselList);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVesselData();
    const interval = setInterval(fetchVesselData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Define the EEZ layer style
  const eezLayer = {
    id: 'eez-layer',
    type: 'fill',
    source: 'eez',
    paint: {
      'fill-color': '#007cbf', // Blue fill color for EEZ polygons
      'fill-opacity': 0.4, // Semi-transparent
      'fill-outline-color': '#000000', // Black outline for visibility
    },
  };

  return (
    <div className="home-map">
      <Map
        initialViewState={viewport}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '20px',
          zoom: 1.5,
        }}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        onMove={(e) => setViewport(e.viewState)}
        ref={mapRef} // Attach ref to Map component
      >
        {/* EEZ Polygon Layer */}
        <Source
          id="eez"
          type="geojson"
          data={eezData}
        >
          <Layer {...eezLayer} />
        </Source>

        {/* Vessel Points */}
        {!isLoading && !error && (
          <MapPoints
            map={mapRef.current?.getMap()}
            positions={vessels}
            onMarkerClick={(data) => {
              const vessel = vessels.find(
                (v) =>
                  v.vesselNumber === data.properties.vesselNumber ||
                  v.deviceId === data.properties.deviceId
              );
              if (vessel && onMarkerClick) {
                onMarkerClick(vessel);
              }
            }}
          />
        )}
      </Map>
      {/* {error && (
        <div className="error-message">Error loading vessel data: {error}</div>
      )} */}
    </div>
  );
};

export default MapboxMap;
